import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { injectViewportBreakpoints } from '@quipex/core/utils';
import { QpxButton, QpxIcon } from '../../directives';

export interface HeaderMenuItem {
    readonly key: string;
    readonly label: string;
    readonly route: string | readonly string[];
    readonly testId?: string;
}

@Component({
    selector: 'qpx-header-menu',
    imports: [
        MatButtonModule,
        MatMenuModule,
        NgIcon,
        QpxButton,
        QpxIcon,
        RouterLink,
    ],
    templateUrl: './header-menu.html',
    styleUrl: './header-menu.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QpxHeaderMenu {
    private readonly viewport = injectViewportBreakpoints();
    protected readonly isPhone = this.viewport.isPhone;
    //#region Inputs
    public readonly activeKey = input.required<string>();
    public readonly ariaLabel = input.required<string>();
    public readonly items = input.required<readonly HeaderMenuItem[]>();
    //#endregion

    //#region State
    protected readonly activeItem = computed(
        () => this.items().find((item) => item.key === this.activeKey()) ?? null
    );
    //#endregion
}
